import React from 'react'
import {useAccountContext} from '../layout/AccountLayout'
import {getNavigationPaths} from '../../services/navigation'
import Breadcrumbs from '../navigation/Breadcrumbs'
import PaymentTabs from '../payment/PaymentTabs'
import {useGetFolioQuery} from '../../services/residentPortalApi'
import PaymentList from './PaymentList'

const PaymentHistoryPage = () => {
  const {accountId} = useAccountContext()
  const paths = getNavigationPaths(accountId)
  const folioQuery = useGetFolioQuery(accountId)

  return (
    <section>
      <Breadcrumbs
        items={[
          {label: 'Account', path: paths.Account, active: false},
          {label: 'Payment History', active: true}
        ]}
      />

      <PaymentTabs accountId={accountId} />

      <div className="card-default w-full">
        <div className="card-body-default">
          <h1 className="card-header">Payment History</h1>
          <PaymentList
            payments={folioQuery?.data?.payments}
            isLoading={folioQuery.isLoading}
          />
        </div>
      </div>
    </section>
  )
}

export default PaymentHistoryPage
